import React, { useState, useEffect ,useContext,useRef} from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import CommonStyle from "../Styles/Common.module.css";
import FontStyle from "../Styles/FontStyle.module.css";
import ButtonStyle from "../Styles/Button.module.css";
import { Link, useParams,useNavigate} from "react-router-dom";
import Search from "./Search";
import { LuSearch } from "react-icons/lu";
import { IMAGE_BASE_URL, API_BASE_URL } from "./../../constants";
import AuthContext from "../../store/auth-context";
import { getTempPropetyDetail, TourRequest } from "../../services/routes.services";
import { LazyLoadImage } from "react-lazy-load-image-component";
import $ from "jquery";
import { IoMdClose, IoMdTime } from "react-icons/io";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import { LightgalleryProvider, LightgalleryItem } from "react-lightgallery";
import "lightgallery.js/dist/css/lightgallery.css";
import ReactPlayer from "react-player";
import { Spinners } from "../Common/Common/Loader";
import { MdOutlineSquareFoot, MdLocationPin } from "react-icons/md";
import { GrStar } from "react-icons/gr";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { CiUser } from "react-icons/ci";
import parse from "html-react-parser";
import Accordion from "react-bootstrap/Accordion";
import { BiRupee } from "react-icons/bi";
import Rating from '@mui/material/Rating';
import Stack from '@mui/material/Stack';
import DateTimeSearch from "./Date&TimeSearch";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import LoginScreen from "../Auth/Login/Login";


const PropertyScreen=()=>{
    const authCtx = useContext(AuthContext);
    //console.log(authCtx)
    const [formData, setFormData] = useState({
      request_for: '',
      });

     const [errors, setErrors] = useState({});
    const { url } = useParams();
    const [productDetail, setProductDetasil] = useState();
    const [forcastContent, setForcastContent] = useState();
    const [imagePopup, setImagePopup] = useState(false);
    const [requestMsg, setRequestMsg] = useState();
    const [spinner, setSpinner] = useState(false);
    const navigate = useNavigate();
    const [requestPop, setRequestPop] = useState(false);
    const [searchBox, setSearchBox ] = useState(false);
    const [textToCopy, setTextToCopy] = useState('Text to be copied');
     const textAreaRef = useRef(null);
    const [showLoginPopup, setShowLoginPopup] = useState(false);
    const showSearchHandler = ()=>{
        setSearchBox(true)
    }
    const closeSearchHandler = ()=>{
        setSearchBox(false)
    }
    //Search


useEffect(() => {
  const fetchInitialDetail = async () => {
    try {
      const response = await getTempPropetyDetail(url);
      setProductDetasil(response.data);
      setRequestMsg(response.data.message);
    } catch (error) {
      console.error("Initial product detail fetch failed:", error);
    }
  };

  fetchInitialDetail();
}, [url]);
//console.log('data without Token ', productDetail)

const handleLoginClick = () => {
  setShowLoginPopup(true);
};
const handleCloseLoginPopup = () => {
    setShowLoginPopup(false);
  };

useEffect(() => {
  if (!productDetail?.time_limit) return;

  const intervalTime = parseInt(productDetail.time_limit) * 60 * 1000;

  const fetchData = async () => {
    try {
      const response = await getTempPropetyDetail(url);
      setProductDetasil(response.data);
      setRequestMsg(response.data.message);
    } catch (error) {
      console.error("Interval fetch failed:", error);
    }
  };

  const interval = setInterval(fetchData, intervalTime);

  return () => clearInterval(interval);
}, [productDetail?.time_limit, url]);

    

    const requestHandler=()=>{
      setRequestPop(true)
    }
    const closeRequestHandler=()=>{
      setRequestPop(false)
    }

    const changeHandler = (e) => {
      setFormData({
        ...formData,
        request_for: e.target.value
      });
    };
    const tourRequestHandler = async (e) => {
      e.preventDefault();
      setSpinner(true)
      const postData = {
        property_id: `${productDetail?.data?.id}`,
        request_for: formData.request_for,
      };
      //console.log(postData)
      try {
        const response = await TourRequest(postData);
        setSpinner(false)
        if(response.data.success === true){  
          setRequestPop(false)
          toast.success(response.data.message);
        }else{
          setRequestPop(false)
          toast.error(response.data.message);
        }
        //console.log("Request successful:", response.data);
      } catch (error) {
        setSpinner(false)
        setRequestPop(false)
        console.error("Request failed:", error.response?.data || error.message);
        toast.error("Failed to send request. Please try again.");
      }
    };
    
    
  const imagebase = productDetail != undefined && productDetail;
  const imageUrl = imagebase.media != undefined &&  imagebase.media;
  const imageUrlexterior = imagebase.exterior != undefined &&  imagebase.exterior;
  const imageUrlinterior = imagebase.interior != undefined &&  imagebase.interior;
  var addWatermark = productDetail?.watermark !== 1;
  var fullDetail = productDetail?.full_info === 1;
   const handleAfterOpen = () => {
    setTimeout(() => {
      if (addWatermark) {
        $(".lg-inner").addClass("with-watermark");
        $(".lg-thumb-outer").addClass("with-watermark");
      } else {
        $(".lg-inner").removeClass("with-watermark");
        $(".lg-thumb-outer").removeClass("with-watermark");
      }
    }, 100); // Delay to ensure DOM is mounted
  };
  
  
  
    const OneImageRender = () => {
        return (
          <div className={CommonStyle.mainGallery}>
            <div className={CommonStyle.galleryRow}>
              <div className={`${CommonStyle.imageContant} ${addWatermark ? CommonStyle.watermarked : ''}`}>
                <button onClick={imageGalleryHandler} type='button'>
                    <img src={IMAGE_BASE_URL + "/property/" + imageUrl[0].image} alt="" />
                    <div className={CommonStyle.VIewwMOreImg}>
                          <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="33" height="31" viewBox="0 0 33 31" fill="none"><path d="M12.185 0.20426H2.6295C1.6243 0.20426 0.80957 1.00167 0.80957 1.98478V11.3333C0.80957 12.3168 1.62463 13.1139 2.6295 13.1139H12.185C13.1902 13.1139 14.0049 12.3164 14.0049 11.3333V1.98478C14.0049 1.00135 13.1898 0.20426 12.185 0.20426ZM12.185 11.3335H2.6295V1.98494H12.185V11.3335ZM12.185 17.5657H2.6295C1.6243 17.5657 0.80957 18.3631 0.80957 19.3462V28.6948C0.80957 29.6782 1.62463 30.4753 2.6295 30.4753H12.185C13.1902 30.4753 14.0049 29.6779 14.0049 28.6948V19.3462C14.0049 18.3631 13.1898 17.5657 12.185 17.5657ZM12.185 28.695H2.6295V19.3464H12.185V28.695ZM30.3859 0.204102H20.8304C19.8252 0.204102 19.0105 1.00151 19.0105 1.98462V11.3332C19.0105 12.3166 19.8255 13.1137 20.8304 13.1137H30.3859C31.3911 13.1137 32.2058 12.3163 32.2058 11.3332V1.98462C32.2058 1.00119 31.3908 0.204102 30.3859 0.204102ZM30.3859 11.3333H20.8304V1.98478H30.3859V11.3333ZM30.3859 17.5656H20.8304C19.8252 17.5656 19.0105 18.363 19.0105 19.3461V28.6946C19.0105 29.6781 19.8255 30.4752 20.8304 30.4752H30.3859C31.3911 30.4752 32.2058 29.6777 32.2058 28.6946V19.3461C32.2058 18.363 31.3908 17.5656 30.3859 17.5656ZM30.3859 28.6948H20.8304V19.3462H30.3859V28.6948Z" fill="white"/></svg>
                            View All
                          </span>
                        </div>
                  </button>
              </div>
            </div>
          </div>
        );
      };
      const TwoImageRender = () => {
        return (
          <div className={CommonStyle.mainGallery}>
            <div className={CommonStyle.galleryRow}>
              <div className={`${CommonStyle.imageContant} ${addWatermark ? CommonStyle.watermarked : ''}`}>
                <button onClick={imageGalleryHandler} type='button'>
                    <img src={IMAGE_BASE_URL + "/property/" + imageUrl[0].image} alt="" />
                  </button>
              </div>
              <div className={`${CommonStyle.imageContant} ${addWatermark ? CommonStyle.watermarked : ''}`}>
                <button onClick={imageGalleryHandler} type='button'>
                  <img src={IMAGE_BASE_URL + "/property/size/" + imageUrl[1].image} alt="" />
                  <div className={CommonStyle.VIewwMOreImg}>
                          <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="33" height="31" viewBox="0 0 33 31" fill="none"><path d="M12.185 0.20426H2.6295C1.6243 0.20426 0.80957 1.00167 0.80957 1.98478V11.3333C0.80957 12.3168 1.62463 13.1139 2.6295 13.1139H12.185C13.1902 13.1139 14.0049 12.3164 14.0049 11.3333V1.98478C14.0049 1.00135 13.1898 0.20426 12.185 0.20426ZM12.185 11.3335H2.6295V1.98494H12.185V11.3335ZM12.185 17.5657H2.6295C1.6243 17.5657 0.80957 18.3631 0.80957 19.3462V28.6948C0.80957 29.6782 1.62463 30.4753 2.6295 30.4753H12.185C13.1902 30.4753 14.0049 29.6779 14.0049 28.6948V19.3462C14.0049 18.3631 13.1898 17.5657 12.185 17.5657ZM12.185 28.695H2.6295V19.3464H12.185V28.695ZM30.3859 0.204102H20.8304C19.8252 0.204102 19.0105 1.00151 19.0105 1.98462V11.3332C19.0105 12.3166 19.8255 13.1137 20.8304 13.1137H30.3859C31.3911 13.1137 32.2058 12.3163 32.2058 11.3332V1.98462C32.2058 1.00119 31.3908 0.204102 30.3859 0.204102ZM30.3859 11.3333H20.8304V1.98478H30.3859V11.3333ZM30.3859 17.5656H20.8304C19.8252 17.5656 19.0105 18.363 19.0105 19.3461V28.6946C19.0105 29.6781 19.8255 30.4752 20.8304 30.4752H30.3859C31.3911 30.4752 32.2058 29.6777 32.2058 28.6946V19.3461C32.2058 18.363 31.3908 17.5656 30.3859 17.5656ZM30.3859 28.6948H20.8304V19.3462H30.3859V28.6948Z" fill="white"/></svg>
                            View All
                          </span>
                        </div>
                </button>
              </div>
            </div>
          </div>
        );
      };
      const ThreeImageRender = () => {
        return (
          <div className={CommonStyle.mainGallery}>
            <div className={CommonStyle.galleryRow}>
              <div className={`${CommonStyle.imageContant} ${addWatermark ? CommonStyle.watermarked : ''}`}>
                <button onClick={imageGalleryHandler} type='button'>
                      <img src={IMAGE_BASE_URL + "/property/" + imageUrl[0].image} alt="" />
                    </button>
              </div>
              <div className={CommonStyle.galleryFlexColm}>
                <div className={CommonStyle.galleryRow}>
                  <div className={`${CommonStyle.imageContant} ${addWatermark ? CommonStyle.watermarked : ''}`}>
                    <button onClick={imageGalleryHandler} type='button'>
                      <img src={IMAGE_BASE_URL + "/property/size/" + imageUrl[1].image} alt="" />
                    </button>
                  </div>
                </div>
                <div className={CommonStyle.galleryRow}>
                  <div className={`${CommonStyle.imageContant} ${addWatermark ? CommonStyle.watermarked : ''}`}>
                    <button onClick={imageGalleryHandler} type='button'>
                      <img src={IMAGE_BASE_URL + "/property/size/" + imageUrl[2].image} alt="" />
                      <div className={CommonStyle.VIewwMOreImg}>
                          <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="33" height="31" viewBox="0 0 33 31" fill="none"><path d="M12.185 0.20426H2.6295C1.6243 0.20426 0.80957 1.00167 0.80957 1.98478V11.3333C0.80957 12.3168 1.62463 13.1139 2.6295 13.1139H12.185C13.1902 13.1139 14.0049 12.3164 14.0049 11.3333V1.98478C14.0049 1.00135 13.1898 0.20426 12.185 0.20426ZM12.185 11.3335H2.6295V1.98494H12.185V11.3335ZM12.185 17.5657H2.6295C1.6243 17.5657 0.80957 18.3631 0.80957 19.3462V28.6948C0.80957 29.6782 1.62463 30.4753 2.6295 30.4753H12.185C13.1902 30.4753 14.0049 29.6779 14.0049 28.6948V19.3462C14.0049 18.3631 13.1898 17.5657 12.185 17.5657ZM12.185 28.695H2.6295V19.3464H12.185V28.695ZM30.3859 0.204102H20.8304C19.8252 0.204102 19.0105 1.00151 19.0105 1.98462V11.3332C19.0105 12.3166 19.8255 13.1137 20.8304 13.1137H30.3859C31.3911 13.1137 32.2058 12.3163 32.2058 11.3332V1.98462C32.2058 1.00119 31.3908 0.204102 30.3859 0.204102ZM30.3859 11.3333H20.8304V1.98478H30.3859V11.3333ZM30.3859 17.5656H20.8304C19.8252 17.5656 19.0105 18.363 19.0105 19.3461V28.6946C19.0105 29.6781 19.8255 30.4752 20.8304 30.4752H30.3859C31.3911 30.4752 32.2058 29.6777 32.2058 28.6946V19.3461C32.2058 18.363 31.3908 17.5656 30.3859 17.5656ZM30.3859 28.6948H20.8304V19.3462H30.3859V28.6948Z" fill="white"/></svg>
                            View All
                          </span>
                        </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      };
      const FourImageRender = () => {
        return (
          <div className={CommonStyle.mainGallery}>
            <div className={CommonStyle.galleryRow}>
              <div className={`${CommonStyle.imageContant} ${addWatermark ? CommonStyle.watermarked : ''}`}>
                  <button onClick={imageGalleryHandler} type='button'>
                    <img src={IMAGE_BASE_URL + "/property/" + imageUrl[0].image} alt="" />
                  </button>
              </div>
              <div className={CommonStyle.galleryFlexColm}>
                <div className={CommonStyle.galleryRow}>
                  <div className={`${CommonStyle.imageContant} ${addWatermark ? CommonStyle.watermarked : ''}`}>
                    <button onClick={imageGalleryHandler} type='button'>
                      <img src={IMAGE_BASE_URL + "/property/size/" + imageUrl[1].image} alt="" />
                    </button>
                  </div>
                </div>
                <div className={CommonStyle.galleryRow}>
                  <div className={`${CommonStyle.imageContant} ${addWatermark ? CommonStyle.watermarked : ''}`}>
                    <button onClick={imageGalleryHandler} type='button'>
                      <img src={IMAGE_BASE_URL + "/property/size/" + imageUrl[2].image} alt="" />
                    </button>
                  </div>
                  <div className={`${CommonStyle.imageContant} ${addWatermark ? CommonStyle.watermarked : ''}`}>
                    <button onClick={imageGalleryHandler} type='button'>
                      <img src={IMAGE_BASE_URL + "/property/size/" + imageUrl[3].image} alt="" />
                      <div className={CommonStyle.VIewwMOreImg}>
                          <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="33" height="31" viewBox="0 0 33 31" fill="none"><path d="M12.185 0.20426H2.6295C1.6243 0.20426 0.80957 1.00167 0.80957 1.98478V11.3333C0.80957 12.3168 1.62463 13.1139 2.6295 13.1139H12.185C13.1902 13.1139 14.0049 12.3164 14.0049 11.3333V1.98478C14.0049 1.00135 13.1898 0.20426 12.185 0.20426ZM12.185 11.3335H2.6295V1.98494H12.185V11.3335ZM12.185 17.5657H2.6295C1.6243 17.5657 0.80957 18.3631 0.80957 19.3462V28.6948C0.80957 29.6782 1.62463 30.4753 2.6295 30.4753H12.185C13.1902 30.4753 14.0049 29.6779 14.0049 28.6948V19.3462C14.0049 18.3631 13.1898 17.5657 12.185 17.5657ZM12.185 28.695H2.6295V19.3464H12.185V28.695ZM30.3859 0.204102H20.8304C19.8252 0.204102 19.0105 1.00151 19.0105 1.98462V11.3332C19.0105 12.3166 19.8255 13.1137 20.8304 13.1137H30.3859C31.3911 13.1137 32.2058 12.3163 32.2058 11.3332V1.98462C32.2058 1.00119 31.3908 0.204102 30.3859 0.204102ZM30.3859 11.3333H20.8304V1.98478H30.3859V11.3333ZM30.3859 17.5656H20.8304C19.8252 17.5656 19.0105 18.363 19.0105 19.3461V28.6946C19.0105 29.6781 19.8255 30.4752 20.8304 30.4752H30.3859C31.3911 30.4752 32.2058 29.6777 32.2058 28.6946V19.3461C32.2058 18.363 31.3908 17.5656 30.3859 17.5656ZM30.3859 28.6948H20.8304V19.3462H30.3859V28.6948Z" fill="white"/></svg>
                            View All
                          </span>
                        </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      };
    
      const FiveImageRender = () => {
        return (
          <div className={CommonStyle.mainGallery}>
            <div className={CommonStyle.galleryRow}>
              <div className={`${CommonStyle.imageContant} ${addWatermark ? CommonStyle.watermarked : ''}`}>
                  <button onClick={imageGalleryHandler} type='button'>
                    <img src={IMAGE_BASE_URL + "/property/" + imageUrl[0].image} alt="" />
                  </button>
              </div>
              <div className={CommonStyle.galleryFlexColm}>
                <div className={CommonStyle.galleryRow}>
                  <div className={`${CommonStyle.imageContant} ${addWatermark ? CommonStyle.watermarked : ''}`}>
                    <button onClick={imageGalleryHandler} type='button'>
                      <img src={IMAGE_BASE_URL + "/property/size/" + imageUrl[1].image} alt="" />
                    </button>
                  </div>
                  <div className={`${CommonStyle.imageContant} ${addWatermark ? CommonStyle.watermarked : ''}`}>
                    <button onClick={imageGalleryHandler} type='button'>
                      <img src={IMAGE_BASE_URL + "/property/size/" + imageUrl[2].image} alt="" />
                    </button>
                  </div>
                </div>
                <div className={CommonStyle.galleryRow}>
                  <div className={`${CommonStyle.imageContant} ${addWatermark ? CommonStyle.watermarked : ''}`}>
                    <button onClick={imageGalleryHandler} type='button'>
                      <img src={IMAGE_BASE_URL + "/property/size/" + imageUrl[3].image} alt="" />
                    </button>
                  </div>
                  <div className={`${CommonStyle.imageContant} ${addWatermark ? CommonStyle.watermarked : ''}`}>
                      <button onClick={imageGalleryHandler} type='button'>
                        <img src={IMAGE_BASE_URL + "/property/size/" + imageUrl[4].image} alt="" />
                        <div className={CommonStyle.VIewwMOreImg}>
                          <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="33" height="31" viewBox="0 0 33 31" fill="none"><path d="M12.185 0.20426H2.6295C1.6243 0.20426 0.80957 1.00167 0.80957 1.98478V11.3333C0.80957 12.3168 1.62463 13.1139 2.6295 13.1139H12.185C13.1902 13.1139 14.0049 12.3164 14.0049 11.3333V1.98478C14.0049 1.00135 13.1898 0.20426 12.185 0.20426ZM12.185 11.3335H2.6295V1.98494H12.185V11.3335ZM12.185 17.5657H2.6295C1.6243 17.5657 0.80957 18.3631 0.80957 19.3462V28.6948C0.80957 29.6782 1.62463 30.4753 2.6295 30.4753H12.185C13.1902 30.4753 14.0049 29.6779 14.0049 28.6948V19.3462C14.0049 18.3631 13.1898 17.5657 12.185 17.5657ZM12.185 28.695H2.6295V19.3464H12.185V28.695ZM30.3859 0.204102H20.8304C19.8252 0.204102 19.0105 1.00151 19.0105 1.98462V11.3332C19.0105 12.3166 19.8255 13.1137 20.8304 13.1137H30.3859C31.3911 13.1137 32.2058 12.3163 32.2058 11.3332V1.98462C32.2058 1.00119 31.3908 0.204102 30.3859 0.204102ZM30.3859 11.3333H20.8304V1.98478H30.3859V11.3333ZM30.3859 17.5656H20.8304C19.8252 17.5656 19.0105 18.363 19.0105 19.3461V28.6946C19.0105 29.6781 19.8255 30.4752 20.8304 30.4752H30.3859C31.3911 30.4752 32.2058 29.6777 32.2058 28.6946V19.3461C32.2058 18.363 31.3908 17.5656 30.3859 17.5656ZM30.3859 28.6948H20.8304V19.3462H30.3859V28.6948Z" fill="white"/></svg>
                            View All
                          </span>
                        </div>
                      </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      };
    
      const SixImageRender = () => {
        return (
          <div className={CommonStyle.mainGallery}>
            <div className={CommonStyle.galleryRow}>
              <div className={`${CommonStyle.imageContant} ${addWatermark ? CommonStyle.watermarked : ''}`}>
                <button onClick={imageGalleryHandler} type='button'>
                  <LazyLoadImage effect='blur' src={IMAGE_BASE_URL + "/property/" + imageUrl[0].image} alt="" />
                </button>
              </div>
              <div className={CommonStyle.galleryFlexColm}>
                <div className={CommonStyle.galleryRow}>
                  <div className={`${CommonStyle.imageContant} ${addWatermark ? CommonStyle.watermarked : ''}`}>
                    <button onClick={imageGalleryHandler} type='button'>
                      <LazyLoadImage effect='blur'  src={IMAGE_BASE_URL + "/property/size/" + imageUrl[1].image} alt="" />
                    </button>
                  </div>
                  <div className={`${CommonStyle.imageContant} ${addWatermark ? CommonStyle.watermarked : ''}`}>
                    <button onClick={imageGalleryHandler} type='button'>
                      <LazyLoadImage effect='blur'  src={IMAGE_BASE_URL + "/property/size/" + imageUrl[2].image} alt="" />
                    </button>
                  </div>
                </div>
                <div className={CommonStyle.galleryRow}>
                  <div className={`${CommonStyle.imageContant} ${addWatermark ? CommonStyle.watermarked : ''}`}>
                    <button onClick={imageGalleryHandler} type='button'>
                      <LazyLoadImage effect='blur'  src={IMAGE_BASE_URL + "/property/size/" + imageUrl[3].image} alt="" />
                    </button>
                  </div>
                  <div className={`${CommonStyle.imageContant} ${addWatermark ? CommonStyle.watermarked : ''}`}>
                    <div className={CommonStyle.overlayBox}>
                      <button onClick={imageGalleryHandler} type='button'>
                        <LazyLoadImage effect='blur'  src={IMAGE_BASE_URL + "/property/size/" + imageUrl[4].image} alt="" />
                        <div className={CommonStyle.VIewwMOreImg}>
                          <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="33" height="31" viewBox="0 0 33 31" fill="none"><path d="M12.185 0.20426H2.6295C1.6243 0.20426 0.80957 1.00167 0.80957 1.98478V11.3333C0.80957 12.3168 1.62463 13.1139 2.6295 13.1139H12.185C13.1902 13.1139 14.0049 12.3164 14.0049 11.3333V1.98478C14.0049 1.00135 13.1898 0.20426 12.185 0.20426ZM12.185 11.3335H2.6295V1.98494H12.185V11.3335ZM12.185 17.5657H2.6295C1.6243 17.5657 0.80957 18.3631 0.80957 19.3462V28.6948C0.80957 29.6782 1.62463 30.4753 2.6295 30.4753H12.185C13.1902 30.4753 14.0049 29.6779 14.0049 28.6948V19.3462C14.0049 18.3631 13.1898 17.5657 12.185 17.5657ZM12.185 28.695H2.6295V19.3464H12.185V28.695ZM30.3859 0.204102H20.8304C19.8252 0.204102 19.0105 1.00151 19.0105 1.98462V11.3332C19.0105 12.3166 19.8255 13.1137 20.8304 13.1137H30.3859C31.3911 13.1137 32.2058 12.3163 32.2058 11.3332V1.98462C32.2058 1.00119 31.3908 0.204102 30.3859 0.204102ZM30.3859 11.3333H20.8304V1.98478H30.3859V11.3333ZM30.3859 17.5656H20.8304C19.8252 17.5656 19.0105 18.363 19.0105 19.3461V28.6946C19.0105 29.6781 19.8255 30.4752 20.8304 30.4752H30.3859C31.3911 30.4752 32.2058 29.6777 32.2058 28.6946V19.3461C32.2058 18.363 31.3908 17.5656 30.3859 17.5656ZM30.3859 28.6948H20.8304V19.3462H30.3859V28.6948Z" fill="white"/></svg>
                            View All
                          </span>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      };
    
      const ImageSource = () => {
        if (imageUrl.length === 0) {
            return null;
        }
    
        switch (true) {
            case imageUrl.length === 2:
                return TwoImageRender();
            case imageUrl.length === 3:
                return ThreeImageRender();
            case imageUrl.length === 4:
                return FourImageRender();
            case imageUrl.length === 5:
                return FiveImageRender();
            case imageUrl.length > 5:
                return SixImageRender();
            default:
                return null;
        }
    };

      const imageGalleryHandler=()=>{
        $(function() {
          $('body').css("overflow", "hidden");
        });
        setImagePopup(true)
       
      }



      const closeGalleyHandler = ()=>{
        $('body').css("overflow", "auto");
        setImagePopup(false)
      }

      const copyToClipboard = () => {
        // Create a temporary textarea element to select and copy text
        const tempTextArea = document.createElement('textarea');
        tempTextArea.value = textToCopy;
        document.body.appendChild(tempTextArea);
        tempTextArea.select();
        document.execCommand('copy');
        document.body.removeChild(tempTextArea);
      };
      let synSound='No';
      let artDirection='No';
      let wallpaint='No';
      if(productDetail != undefined ){
        if(productDetail.data && productDetail.data.art_direction===0){
          artDirection='No';
        }
        else{
          artDirection='Yes';
        }
        if(productDetail.data && productDetail.data.wall_paint===0){
          wallpaint='No';
        }
        else if(productDetail.data && productDetail.data.wall_paint===1){
          wallpaint='Yes';
        }
        else {
          wallpaint='Yes (if changed back)';
        }
      if(productDetail.data && productDetail.data.sync_sound ===0){
        synSound='No';
      }
      else if(productDetail.data && productDetail.data.sync_sound ===1){
        synSound='Mid';
      }
      else if(productDetail.data && productDetail.data.sync_sound ===2){
        synSound='High';
      }
      }
    
    const smoothScroll = (URL, id) => {
        window.scroll({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      };
      const handleCallback = (data) => {};
      const handleLogoutClick = () => {
        authCtx.logout();
        navigate('/searchResult');
    };
    if(forcastContent!=undefined){
      let locationdate = new Date(forcastContent.location.localtime);
      var locday = locationdate.toLocaleString('en-us', {weekday: 'long'})
    }
    const responsiveworkFlow = {
      superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 1025 },
        items: 3,
      },
      desktop: {
        breakpoint: { max: 1024, min: 0 },
        items: 3,
      },
    };

    return(
        <div className={CommonStyle.searchResultPage + " " + CommonStyle.headerSpace}>
            <div className={CommonStyle.breadCrumb}>
                <Container>
                <Row>
                    <Col className={CommonStyle.ulFlex}>
                    <ul>
                        {authCtx.isLoggedIn ?
                          <>
                            <li><Link to="/" onClick={smoothScroll}>Home</Link></li>
                            <li><Link to="/dashboard" onClick={smoothScroll}>Dashboard</Link></li>
                            <li>{productDetail?.data?.location_code}</li>
                          </>
                          :
                          <>
                            <li><Link to="/" onClick={smoothScroll}>Home</Link></li>
                            <li>{productDetail?.data?.location_code}</li>
                          </>
                        }
                    </ul>
                    {authCtx.isLoggedIn && <Link to="#" onClick={(e) => {e.preventDefault();handleLogoutClick();}} title='Logout'>Logout</Link>}
                    </Col>
                </Row>
                </Container>
            </div>
            
            <div className={CommonStyle.SearchFilter}>
                <Container>
                    <Row>
                        <Col>
                        <div className={CommonStyle.responsiveView + ' ' + CommonStyle.tabSearch}>
                            <button type="button" onClick={showSearchHandler} className={ ButtonStyle.defaultButton + " " + CommonStyle.tabSearchButton}>
                                Search Now <LuSearch className={ButtonStyle.buttonArrow} />
                            </button>
                        </div>
                        {searchBox && 
                            <div className={CommonStyle.searchOverLay}>
                            <div className={CommonStyle.tabSerachContainer}>
                                <button type='button' onClick={closeSearchHandler} className={CommonStyle.closeSearch}><svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none"><path d="M25.1111 10.8889L10.8889 25.1111M10.8889 10.8889L25.1111 25.1111M34 18C34 26.8366 26.8366 34 18 34C9.16345 34 2 26.8366 2 18C2 9.16345 9.16345 2 18 2C26.8366 2 34 9.16345 34 18Z" stroke="white" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round"/></svg></button>
                                <Search parentCallback={handleCallback} />
                            </div>
                            </div> 
                        }
                        <div className={CommonStyle.searchBrownBg + ' ' + CommonStyle.desktopView}>
                            <Search parentCallback={handleCallback} />
                        </div>
                        </Col>
                    </Row>
                </Container>
                {requestMsg && <div className={CommonStyle.midMsg}><span className={CommonStyle.successMsg}>{requestMsg}</span></div>}
                <div className={CommonStyle.CategoryDetails}>
                    <Container>
                        <Row>
                            <Col className={CommonStyle.detailHeader}>
                                <div className={CommonStyle.locationDetails}>
                                    <h3 className={ FontStyle.Axiforma600 + " " + FontStyle.BlackColor}>{productDetail?.data?.location_code}</h3>
                                    {fullDetail &&
                                    <>
                                      <p><MdLocationPin color="#E71212" fontSize={22} />{" "}{productDetail.data && productDetail.data.location_name}</p>
                                      <ul>
                                        {productDetail.data.location_type == "1"
                                          ?
                                          <>
                                          {productDetail.data.filmography != ''
                                            ? 
                                            <li><GrStar color="#FA8846" className={CommonStyle.detailIcon} />
                                            <OverlayTrigger
                                              overlay={<Tooltip>{productDetail.data.filmography}</Tooltip>}
                                              placement="bottom"
                                              delayShow={300}
                                              delayHide={150}
                                            >
                                              <span>filmography</span>
                                            </OverlayTrigger>
                                              </li>
                                              : null
                                          }
                                          {productDetail.data.interior_capa != null
                                            ? 
                                              <li><CiUser className={CommonStyle.detailIcon} />{" "}{productDetail.data.interior_capa} interior capacity</li>
                                            : null
                                          }
                                          {productDetail.data.exterior_capa != null 
                                            ? 
                                              <li><CiUser className={CommonStyle.detailIcon} />{" "}{productDetail.data.exterior_capa} exterior capacity</li>
                                            : null
                                          }
                                          {productDetail.data.minimum_booking_day != null
                                            ?
                                              <li><IoMdTime className={CommonStyle.detailIcon} />{" "}{productDetail.data.minimum_booking_day} day</li>
                                            : null 
                                          }
                                          </>
                                          : null
                                        }
                                        {productDetail.data.property_area != null
                                          ? 
                                          <li><MdOutlineSquareFoot className={CommonStyle.detailIcon}/>{" "}{productDetail.data.property_area}</li>
                                          : null
                                        }
                                      </ul>
                                      </>
                                    }
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
                {productDetail?.video && (
                    <div className={CommonStyle.proVideo}>
                        <Container>
                        <Row>
                            <Col className={CommonStyle.botterMark}>
                            {productDetail.video.vertual_file === null ?
                                <ReactPlayer
                                url={productDetail.video.youtube_link}
                                controls
                                width="100%"
                                height="100%"
                              />
                              :
                              <ReactPlayer
                                url={IMAGE_BASE_URL + "/vertualTourProperty/" + productDetail.video.vertual_file}
                                controls
                                width="100%"
                                height="100%"
                              />
                            }                              
                            </Col>
                        </Row>
                        </Container>
                    </div>
                    )}
                <Container>
                  <Row>
                    <Col>
                        <div className={CommonStyle.detailGallery}>
                            {[1].includes(imageUrl.length)  && OneImageRender()}
                            <ImageSource />
                            {productDetail?.type === 1 ? 
                              <div className={CommonStyle.requestBtn}>
                                {authCtx.isLoggedIn ?
                                  <button onClick={requestHandler} type="button" className={ButtonStyle.largeButton + ' ' + ButtonStyle.roundStyle + ' ' + ButtonStyle.orangeStyle} >Send Request for Virtual Tour</button> 
                                  :
                                  <button onClick={handleLoginClick} type="button" className={ButtonStyle.largeButton + ' ' + ButtonStyle.roundStyle + ' ' + ButtonStyle.orangeStyle} >Send Request for Virtual Tour</button> 
                                }
                              </div>
                              : null
                            }
                        </div>
                        {requestPop &&
                          <div className='requestPopup'>
                            <div className='requestPopupContainer'>
                              <span className='closeBox' onClick={closeRequestHandler}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
                                  <path d="M23.6795 10.5306L10.0306 24.1795M10.0306 10.5306L23.6795 24.1795M32.2101 17.355C32.2101 25.8354 25.3354 32.7101 16.855 32.7101C8.37469 32.7101 1.5 25.8354 1.5 17.355C1.5 8.87469 8.37469 2 16.855 2C25.3354 2 32.2101 8.87469 32.2101 17.355Z" stroke="black" strokeWidth="2.05917" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                              </span>
                              <form onSubmit={tourRequestHandler} className="reqBlock">
                                <textarea placeholder="Request For" value={formData.request_for} onChange={changeHandler} required />
                                <input type="hidden" value={formData.request_for}/>
                                <button type='submit' className={ButtonStyle.largeButton + ' ' + ButtonStyle.roundStyle + ' ' + ButtonStyle.orangeStyle} >Send Request</button> 
                                </form >
                            </div>
                        </div>
                        }
                    </Col>
                  </Row>
                </Container>
                {fullDetail &&
                  <div className={CommonStyle.categoryGallery}>
                    <Container>
                      <Row>
                        <Col>
                          <div className={CommonStyle.enterHotel}>
                            <p>
                              {productDetail.data.location_code && 'Location Code :'} {productDetail.data.location_code}
                            </p>
                          </div>
                        </Col>
                      </Row>
                      <Row className={CommonStyle.detailPropty}>
                        <Col sm={8} className={CommonStyle.detailProptyleft}>
                          <div className={CommonStyle.abouthost}>
                            
                            <div className={CommonStyle.aboutSpace}>
                              <h5 className={FontStyle.Axiforma500}>About the space</h5>
                              <p className={FontStyle.BlackColor}>{parse(`${productDetail.data.about_property}`)}</p>
                            </div>
                            {productDetail.data.additional_permit != null 
                                ?
                                <div className={CommonStyle.aboutSpace}>
                                    <h5 className={FontStyle.Axiforma500}>Additional Permit</h5>
                                    <p>{productDetail.data.additional_permit}</p>
                                </div>
                                : null
                              }
                            <div className="bookingDetail">
                              {productDetail.amenities && productDetail.amenities.length !==0
                                ?
                                <Accordion defaultActiveKey="0">
                                  <Accordion.Item>
                                    <Accordion.Header><h5 className={FontStyle.Axiforma500}>Amenities</h5></Accordion.Header>
                                      {productDetail.amenities.map((item) =>{
                                        return(
                                          <Accordion.Body key={item.id}><p>{item.name}</p></Accordion.Body>
                                        )
                                      })}
                                      {productDetail.data.other_amenities != null && <Accordion.Body><p>{productDetail.data.other_amenities}</p></Accordion.Body>}
                                  </Accordion.Item>
                                </Accordion>
                                : null
                              }
                              {productDetail.location_tags && productDetail.location_tags.length !==0
                                ?
                                <Accordion defaultActiveKey="0">
                                  <Accordion.Item>
                                    <Accordion.Header><h5 className={FontStyle.Axiforma500}>Tags</h5></Accordion.Header>
                                      {productDetail.location_tags.map((item) =>{
                                        return(
                                          <Accordion.Body key={item.id}><p>{item.title}</p></Accordion.Body>
                                        )
                                      })}
                                  </Accordion.Item>
                                </Accordion>
                                : null
                              }
                              {productDetail.information_passed && productDetail.information_passed.length !==0 && productDetail.data.location_type ===2
                                ?
                                <Accordion defaultActiveKey="0">
                                  <Accordion.Item>
                                    <Accordion.Header><h5 className={FontStyle.Axiforma500}>Information to be passed on to</h5></Accordion.Header>
                                      {productDetail.information_passed.map((item) =>{
                                        return(
                                          <Accordion.Body key={item.id}><p>{item.name}</p></Accordion.Body>
                                        )
                                      })}
                                  </Accordion.Item>
                                </Accordion>
                                : null
                              }
                              {productDetail.data.permision_process != null  && productDetail.data.location_type ===2
                                ?
                                <Accordion defaultActiveKey="0">
                                  <Accordion.Item>
                                    <Accordion.Header><h5 className={FontStyle.Axiforma500}>Permission process</h5></Accordion.Header>
                                      
                                          <Accordion.Body><p>{parse(`${productDetail.data.permision_process}`)}</p></Accordion.Body>
                                        
                                  </Accordion.Item>
                                </Accordion>
                                : null
                              }
                              {productDetail.data.additional !=null && productDetail.data.location_type ===2
                                ?
                                <Accordion defaultActiveKey="0">
                                  <Accordion.Item>
                                    <Accordion.Header><h5 className={FontStyle.Axiforma500}>Granting Body</h5></Accordion.Header>
                                      
                                          <Accordion.Body><p>{productDetail.data.additional}</p></Accordion.Body>
                                        
                                  </Accordion.Item>
                                </Accordion>
                                : null
                              }                          
                              </div>
                              <div className="bookingDetail">
                              {productDetail?.video?.length > 0 ? (
                              <Accordion defaultActiveKey="0">
                                <Accordion.Item>
                                  <Accordion.Header>
                                    <h5 className={FontStyle.Axiforma500}>Video</h5>
                                  </Accordion.Header>
                                  {productDetail.video.map((item) => (
                                    <Accordion.Body key={item.id}>
                                      <p>
                                        <a href={item.url} target="_blank" rel="noopener noreferrer">
                                          {item.url}
                                        </a>
                                      </p>
                                    </Accordion.Body>
                                  ))}
                                </Accordion.Item>
                              </Accordion>
                            ) : null}
                              </div>
                              <div className="bookingDetail">
                                {productDetail.data.cancellation_policy != null
                                  ?
                                  <Accordion defaultActiveKey="0">
                                    <Accordion.Item>
                                      <Accordion.Header><h5 className={FontStyle.Axiforma500}>Cancellation Policy</h5></Accordion.Header>
                                            <Accordion.Body><p>{productDetail.data.cancellation_policy}</p></Accordion.Body>
                                    </Accordion.Item>
                                  </Accordion>
                                  : null
                                }
                              </div>
                              <div className="bookingDetail">
                                {productDetail.data.coordinates !=null
                                ?
                                <Accordion defaultActiveKey="0">
                                  <Accordion.Item>
                                    <Accordion.Header><h5 className={FontStyle.Axiforma500}>Sun path</h5></Accordion.Header>

                                          <Accordion.Body>
                                          <div onClick={copyToClipboard} style={{ cursor: 'pointer' }}>
                                          <div ref={textAreaRef}>{textToCopy}</div>
                                          
                                          </div>
                                          Plan according to the golden hour <a href="https://andrewmarsh.com/apps/staging/sunpath3d.html" target="_blank"> see sun direction </a><p>( Copy the above coordinates and paste them in the search bar of the sun path provided. )</p>
                                            </Accordion.Body>
                                        
                                  </Accordion.Item>
                                </Accordion>
                                : null
                              }
                              </div>
                              <div className="bookingDetail">
                                {productDetail.data.host_add_ons != null
                                  ?
                                  <Accordion defaultActiveKey="0">
                                    <Accordion.Item>
                                      <Accordion.Header><h5 className={FontStyle.Axiforma500}>Host add ons</h5></Accordion.Header>
                                            <Accordion.Body><p>{productDetail.data.host_add_ons}</p></Accordion.Body>
                                    </Accordion.Item>
                                  </Accordion>
                                  : null
                                }
                              </div>
                              <div className="bookingDetail">
                                {productDetail.data.health_n_cleaning != null
                                  ?
                                  <Accordion defaultActiveKey="0">
                                    <Accordion.Item>
                                      <Accordion.Header><h5 className={FontStyle.Axiforma500}>Health and cleanings</h5></Accordion.Header>
                                            <Accordion.Body><p>{productDetail.data.health_n_cleaning}</p></Accordion.Body>
                                    </Accordion.Item>
                                  </Accordion>
                                  : null
                                }
                              </div>
                              <div className="bookingDetail">
                              {productDetail.data.property_rules !=null
                                ?
                                <Accordion defaultActiveKey="0">
                                  <Accordion.Item>
                                    <Accordion.Header><h5 className={FontStyle.Axiforma500}>Property Rules</h5></Accordion.Header>
                                      
                                          <Accordion.Body ><p>{productDetail.data.property_rules}</p></Accordion.Body>
                                      
                                  </Accordion.Item>
                                </Accordion>
                                : null
                              }
                              </div>
                            <div className={CommonStyle.hostLocation}>
                              {productDetail.data.coordinates === null 
                                ? null 
                                :''
                              }
                                <div className={CommonStyle.crewSpace}>
                                {productDetail.data.elec_charge != null 
                                    ?
                                    <div className={CommonStyle.Box}>
                                        <h4>Electricity Charges</h4>
                                        <span>{productDetail.data.elec_charge}</span>
                                    </div>
                                    : null
                                  }
                                  {productDetail.data.closest_airport != null 
                                    ?
                                    <div className={CommonStyle.Box}>
                                        <h4>Closest Airport</h4>
                                        <span>{productDetail.data.closest_airport}</span>
                                    </div>
                                    : null
                                  }
                                  {productDetail.data.closest_railway != null 
                                    ?
                                    <div className={CommonStyle.Box}>
                                        <h4>Closest Railway Station</h4>
                                        <span>{productDetail.data.closest_railway}</span>
                                    </div>
                                    : null
                                  }
                                  {productDetail.data.distance_city != null 
                                    ?
                                    <div className={CommonStyle.Box}>
                                        <h4>Distance from city centre</h4>
                                        <span>{productDetail.data.distance_city}</span>
                                    </div>
                                    : null
                                  }
                                  {productDetail.data.closest_national != null 
                                    ?
                                    <div className={CommonStyle.Box}>
                                        <h4>Closest National / State highway</h4>
                                        <span>{productDetail.data.closest_national}</span>
                                    </div>
                                    : null
                                  }
                                  {productDetail.data.closest_bus_stand != null 
                                    ?
                                    <div className={CommonStyle.Box}>
                                        <h4>Closest bus stand</h4>
                                        <span>{productDetail.data.closest_bus_stand}</span>
                                    </div>
                                    : null
                                  }
                                  {productDetail.data.closest_hospital != null 
                                    ?
                                    <div className={CommonStyle.Box}>
                                        <h4>Closest hospital</h4>
                                        <span>{productDetail.data.closest_hospital}</span>
                                    </div>
                                    : null
                                  }
                                  </div>
                                  <div className={CommonStyle.crewSpace}>
                              
                                  {productDetail.data.wall_paint != null 
                                    ?
                                    <div className={CommonStyle.Box}>
                                        <h4>Wall paint</h4>
                                        <span>{wallpaint}</span>
                                    </div>
                                    : null
                                  }
                                  {productDetail.data.art_direction != null 
                                    ?
                                    <div className={CommonStyle.Box}>
                                        <h4>Art direction</h4>
                                        <span>{artDirection}</span>
                                    </div>
                                    : null
                                  }
                                  {productDetail.data.sync_sound != null
                                    ?
                                    <div className={CommonStyle.Box}>
                                        <h4>Sync Sound</h4>
                                        <span>{synSound}</span>
                                    </div>
                                    : null
                                  }
                                
                                </div>
                                <div className={CommonStyle.crewSpace}>
                                    {productDetail.data.dismantle_d_cost != null 
                                        ?
                                        <div className={CommonStyle.Box}>
                                            <h4>Dismantle day cost</h4>
                                            <span>{productDetail.data.dismantle_d_cost}</span>
                                        </div>
                                        : null
                                      }
                                </div>
                                <div className={CommonStyle.crewSpace}>
                                    {productDetail.data.reciept_price != null && productDetail.data.location_type ===2
                                        ?
                                        <div className={CommonStyle.Box}>
                                            <h4>Reciept price</h4>
                                            <span><BiRupee className={CommonStyle.rupeIcon} /> {productDetail.data.reciept_price}</span>
                                        </div>
                                        : null
                                      }
                                </div>
                                <div className={CommonStyle.crewSpace}>
                                    {productDetail.data.refundable_deposite != null && productDetail.data.location_type ===2
                                        ?
                                        <div className={CommonStyle.Box}>
                                            <h4>Refundable deposit</h4>
                                            <span><BiRupee className={CommonStyle.rupeIcon} /> {productDetail.data.refundable_deposite}</span>
                                        </div>
                                        : null
                                      }
                                </div>
                                <div className={CommonStyle.crewSpace}>
                                    {productDetail.data.setting_d_cost != null 
                                        ?
                                        <div className={CommonStyle.Box}>
                                            <h4>Setting day cost</h4>
                                            <span>{productDetail.data.setting_d_cost}</span>
                                        </div>
                                        : null
                                      }
                                </div>
                                
                                <div className={CommonStyle.crewSpace}>
                                    {productDetail.data.deposit != null 
                                        ?
                                        <div className={CommonStyle.Box}>
                                            <h4>Deposit</h4>
                                            <span> {productDetail.data.deposit}</span>
                                        </div>
                                        : null
                                      }
                                </div>
                                <div className={CommonStyle.openTime}>
                                  {productDetail.data.operations_days != null 
                                    ?
                                    <div className={CommonStyle.weekTime}>
                                      
                                        <span className={CommonStyle.rightSpace}><h4>Operational Days:</h4> {productDetail.data.operations_days}</span>
                                        <span><h4>Response time:</h4>  {productDetail.data.operations_hours}</span>
                                    </div>
                                    : null
                                  }
                                    {productDetail.data.price_by===1 && 
                                    <div className={CommonStyle.crewSpace}>
                                      {productDetail.data.price_above_50 != null 
                                        ?
                                        <div className={CommonStyle.Box}>
                                            <h4>Price Crew 50</h4>
                                            <span><BiRupee className={CommonStyle.rupeIcon} /> {productDetail.data.price_above_50}</span>
                                        </div>
                                        : null
                                      }
                                      {productDetail.data.price_between_50_100 != null 
                                        ?
                                        <div className={CommonStyle.Box}>
                                            <h4>Price Crew 50-100</h4>
                                            <span><BiRupee className={CommonStyle.rupeIcon} /> {productDetail.data.price_between_50_100}</span>
                                        </div>
                                        : null
                                      }
                                      {productDetail.data.price_100_plus != null 
                                        ?
                                        <div className={CommonStyle.Box}>
                                            <h4>Price Crew 100+</h4>
                                            <span><BiRupee className={CommonStyle.rupeIcon} /> {productDetail.data.price_100_plus}</span>
                                        </div>
                                        : null
                                      }
                                      {productDetail.data.price_crew_size != null 
                                        ?
                                        <div className={CommonStyle.Box}>
                                            <h4>Price any crew size</h4>
                                            <span><BiRupee className={CommonStyle.rupeIcon} /> {productDetail.data.price_crew_size}</span>
                                        </div>
                                        : null
                                      }
                                      {productDetail.data.discount != null 
                                        ?
                                        <div className={CommonStyle.Box}>
                                            <h4>Discount on bulk</h4>
                                            <span>{productDetail.data.discount}% on {productDetail.data.discount_days} days</span>
                                        </div>
                                        : null
                                      }
                                    </div>
                                    }
                                    
                                </div>
                            </div>
                            <div className={CommonStyle.hostDetail}>
                              <div className={CommonStyle.hostName}>
                                <div>
                                <h5 className={FontStyle.Axiforma600} style={{paddingBottom:"5px"}}>
                                    {"Easyrecce Logistic rating"}
                                    
                                  </h5>
                                
                                  <Stack spacing={1} >
            
                                    <Rating name="size-medium"  precision={0.5} value={productDetail.data.rating} disabled/>
                                  
                                  </Stack>
                                    
                                
                                </div>
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col sm={4} className={CommonStyle.detailProptyRight}>
                          <div className={CommonStyle.daySearch}>
                            
                          {productDetail.data.price_by===1 && 
                            <h2 className={FontStyle.Axiforma600}>
                              {productDetail.data.location_type === 1 ? 
                                <>
                                INR {' '}
    
                                { productDetail.data.price_above_50==null?productDetail.data.price_between_50_100:productDetail.data.price_above_50}
                                
                                {'- '}{productDetail.data.price_100_plus}
                                {productDetail.data.price_crew_size!=null?productDetail.data.price_crew_size:''}
                                </>
                                : 'Price on Request'
                              }
                            </h2>
                          }
                          {productDetail.data.price_by===2 && 
                          <div className={CommonStyle.dateSerach}>
                            <div className={CommonStyle.crewSpace + ' ' + CommonStyle.searchForm}>
                              <h6 className={FontStyle.Axiforma500 + ' ' + FontStyle.OrangeColor}>A complete pricing with additional permits and your setting, shooting, dismantling details will be sent to you when you initiate your booking.</h6>
                            {productDetail.data.feature_films != null 
                              ?
                              <p>
                              Feature Films Price : <span><BiRupee className={CommonStyle.rupeIcon} />{productDetail.data.feature_films}</span>
                              </p>
                              : null
                            }
                            {productDetail.data.web_shows != null 
                              ?
                              
                              <p>
                              Web Shows Price : <span><BiRupee className={CommonStyle.rupeIcon} /> {productDetail.data.web_shows}</span>
                              </p>
                              : null
                            }
                            {productDetail.data.ad_films_commercials != null 
                              ?
                              
                              <p>
                              Ad Films Commercials Price : <span><BiRupee className={CommonStyle.rupeIcon} /> {productDetail.data.ad_films_commercials}</span>
                              </p>
                              : null
                            }
                            {productDetail.data.television != null 
                              ?
                              
                              <p>
                              Television Price : <span><BiRupee className={CommonStyle.rupeIcon} /> {productDetail.data.television}</span>
                              </p>
                              : null
                            }
                            {productDetail.data.photography != null 
                              ?
                              
                              <p>
                              Photography Price : <span><BiRupee className={CommonStyle.rupeIcon} /> {productDetail.data.photography}</span>
                              </p>
                              : null
                            }
                            {productDetail.data.sketches_reels_wedding_photography != null 
                              ?
                              
                              <p>
                              Sketch Reels Wedding Photography Price : <span><BiRupee className={CommonStyle.rupeIcon} /> {productDetail.data.sketches_reels_wedding_photography}</span>
                              </p>
                              : null
                            }
                            </div>
                          </div>
                          }
                            {productDetail.data.location_type == 1 && authCtx.userData && authCtx.userData.lister===0 ?  <DateTimeSearch url={url} productDetail={productDetail} /> : null}
                            {forcastContent!=undefined &&
                            <div className={CommonStyle.dateSerach}>
                              <h6 className={FontStyle.Axiforma500 + ' ' + FontStyle.BlackColor}>Forecast</h6>
                                <div className={CommonStyle.searchForm + ' ' + CommonStyle.searchFormWeather}>
                                  <div className={CommonStyle.weatherBoxPadding}>
                                    <div className={CommonStyle.forcastweather}>
                                      <h5>Weather</h5>
                                      <h6 className={FontStyle.Axiforma500 + ' ' + FontStyle.BlackColor}>{locday}</h6>
                                      <p>{forcastContent.location.localtime}</p>
                                      <h6 className={FontStyle.Axiforma500 + ' ' + FontStyle.BlackColor}>{forcastContent.current.condition.text}</h6>
                                    </div>
                                    <div>
                                    <img src={forcastContent.current.condition.icon}/><span>{forcastContent.current.temp_c}'C</span>
                                    </div>
                                  </div>
                                <div className={'weatherOwl ' + CommonStyle.farcastmultidatebox}>
                                  <Carousel responsive={responsiveworkFlow} showDots={false}>
                                    {
                                    forcastContent.forecast.forecastday.map((mosam)=>{ 
                                      let date = new Date(mosam.date);
                                      let day = date.toLocaleString('en-us', {weekday: 'short'});
    
                                      return(
                                        <div className={CommonStyle.farcastmultidate}>
                                          <h6>{day}</h6>
                                          <p>
                                          <img src={mosam.day.condition.icon}/>
                                          </p> 
                                          <p>Max : {mosam.day.maxtemp_c}'C </p>
                                          <p>Min : {mosam.day.mintemp_c}'C </p>
                                        </div>
                                      )
                                    })
                                    }
                                    </Carousel>
                                </div>
    
                              
                                </div>
                            </div>
    }
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </div>
                }
            </div>
            
            {imagePopup && 
            <div className={CommonStyle.imagePopup}>
              <button type='button' className={CommonStyle.closeGallery} onClick={closeGalleyHandler}><IoMdClose /></button>
              <div className={CommonStyle.popupContainer}>
                
                <div className={CommonStyle.imageRow}>
                  {
                    imageUrlexterior.length!="0"?(
                      <div className={CommonStyle.imageColInterior}>
                      <h5>Exterior</h5>
                      <div  className={CommonStyle.imageCol}>
                      <LightgalleryProvider
                        lightgallerySettings={{
                          download: false,
                        }}
                      >
                        {imageUrlexterior.map((items, index) => (
                          <LightgalleryItem key={index} group="group1" src={IMAGE_BASE_URL + "/property/" + items.image}>
                            <a onClick={addWatermark ? handleAfterOpen : undefined} className={`${CommonStyle.imgCont} ${addWatermark ? CommonStyle.watermarked : ''}`}>
                              <img src={IMAGE_BASE_URL + "/property/" + items.image} alt="" className="lightbox-thumb"/>
                            </a>
                          </LightgalleryItem>
                        ))}
                      </LightgalleryProvider>
                      </div>
                      </div>
                ):null}
                {
                    imageUrlinterior.length!="0"?(
                      <div className={CommonStyle.imageColInterior}>
                        <h5>Interior</h5>
                        <div  className={CommonStyle.imageCol}>
                            <LightgalleryProvider
                              lightgallerySettings={{
                                download: false,
                              }}
                            >
                          {imageUrlinterior.map((items, index) => (
                            <LightgalleryItem key={index} group="group2" src={IMAGE_BASE_URL + "/property/" + items.image}>
                              <a onClick={addWatermark ? handleAfterOpen : undefined} className={`${CommonStyle.imgCont} ${addWatermark ? CommonStyle.watermarked : ''}`}>
                                <img src={IMAGE_BASE_URL + "/property/" + items.image} alt="" className="lightbox-thumb"/>
                              </a>
                            </LightgalleryItem>
                          ))}
                          </LightgalleryProvider>
                        </div>
                  </div>):null}
                </div>
              </div>
            </div>
          }
          {showLoginPopup && <LoginScreen onClose={handleCloseLoginPopup} pageName={"SearchResult"}/>}
          {spinner && <Spinners /> }
          <ToastContainer
  position="top-right"
  autoClose={3000}
  hideProgressBar={false}
  newestOnTop={false}
  closeOnClick
  pauseOnFocusLoss
  draggable
  pauseOnHover
/>
        </div>
    )
}

export default PropertyScreen;